import type { DropdownFilterItemContent } from '@carboncopyco/ui';
import get from 'lodash-es/get';

type useFilterLogicProps<T> = {
  data: T[] | undefined;
  selectedItems: Record<string, string>;
  setter: (item: Record<string, string>) => void;
  id: string | number;
  label: string;
};

export const useFilterLogic = <T extends object>({
  data,
  selectedItems,
  setter,
  id,
  label,
}: useFilterLogicProps<T>): [
  DropdownFilterItemContent<string>[],
  (id: string) => void,
] => {
  const items: DropdownFilterItemContent<string>[] =
    data?.map((item) => ({
      ...item,
      id: get(item, id),
      label: get(item, label) ?? '',
    })) ?? [];

  const onChange = (id: string) => {
    if (selectedItems[id]) {
      const { [id]: idToRemove, ...rest } = selectedItems;
      setter(rest);
    } else {
      const label = items?.find((item) => item.id === id)?.label ?? '';
      setter({ ...selectedItems, [id]: label });
    }
  };

  return [items, onChange];
};
